import { DND_GRID_AREA_BACKGROUND_CLASS_NAME, DND_GRID_AREA_SECTION_CLASS_NAME, DND_GRID_AREA_SECTION_CONTENT_CLASS_NAME, GRID_DATA_ATTRIBUTE_NODE_MAP, DND_GRID_AREA_CONTAINER_CLASS_NAME, DND_GRID_AREA_MODULE_CLASS_NAME, DND_GRID_AREA_MODULE_ELEMENT_ID_PREFIX, DND_GRID_AREA_BACKGROUND_LAYER_CLASS_NAME_PREFIX, DND_GRID_AREA_SECTION_CONTENT_CLASS_NAME_PREFIX, DND_GRID_AREA_SECTION_CLASS_NAME_PREFIX, DND_GRID_AREA_CONTAINER_CLASS_NAME_PREFIX, DND_GRID_AREA_MODULE_RENDERER_CLASS_NAMES, DND_GRID_AREA_BACKGROUND_LAYERS_WRAPPER_CLASS_NAME_PREFIX } from './constants';
import { GRID_NODE_TYPES } from 'layout-data-lib/GridLayoutDataTree/constants';
// @ts-expect-error not yet typed
import { addOrRemoveClassesToElement } from 'layout-dnd-utils/dom/manipulators';
import { isBackgroundLayerColor, isBackgroundLayerGradient, isBackgroundLayerImage } from 'layout-data-lib/GridLayoutDataTree/typenameUtils';

// TODO: See if we'll still need this in inpage for syncing node classes
export function updateNodeElementClasses(element, currentNodeClasses = '', previousNodeClasses = '') {
  if (currentNodeClasses || previousNodeClasses) {
    const previousClasses = previousNodeClasses ? previousNodeClasses.split(' ') : [];
    const currentClasses = currentNodeClasses ? currentNodeClasses.split(' ') : [];
    addOrRemoveClassesToElement(element, previousClasses, currentClasses);
  }
}
export function createBackgroundLayerElement(type, nodeId, breakpoint, layerIndex) {
  const backgroundLayerElement = document.createElement('div');
  backgroundLayerElement.classList.add(`${DND_GRID_AREA_BACKGROUND_LAYER_CLASS_NAME_PREFIX}${type}-${nodeId}-${breakpoint}-${layerIndex}`);
  return backgroundLayerElement;
}
export function createBackgroundImageLayerElement(backgroundLayer, nodeId, breakpoint, layerIndex) {
  const backgroundLayerElement = document.createElement('img');
  backgroundLayerElement.classList.add(`${DND_GRID_AREA_BACKGROUND_LAYER_CLASS_NAME_PREFIX}image-${nodeId}-${breakpoint}-${layerIndex}`);
  backgroundLayerElement.src = backgroundLayer.imageUrl;
  return backgroundLayerElement;
}
export function createBackgroundLayersElement(gridNode) {
  const div = document.createElement('div');
  div.classList.add(DND_GRID_AREA_BACKGROUND_CLASS_NAME);
  const nodeId = gridNode.getId();
  const {
    styles
  } = gridNode.getValue();
  Object.entries(styles.breakpointStyles).forEach(([breakpoint, style]) => {
    const {
      backgroundLayers
    } = style;
    if (!backgroundLayers) {
      return;
    }
    const backgroundLayerWrapper = document.createElement('div');
    backgroundLayerWrapper.classList.add(`${DND_GRID_AREA_BACKGROUND_LAYERS_WRAPPER_CLASS_NAME_PREFIX}${nodeId}-${breakpoint}`);
    backgroundLayers.forEach((backgroundLayer, index) => {
      if (isBackgroundLayerColor(backgroundLayer)) {
        const backgroundLayerElement = createBackgroundLayerElement('color', nodeId, breakpoint, index);
        backgroundLayerWrapper.appendChild(backgroundLayerElement);
      } else if (isBackgroundLayerGradient(backgroundLayer)) {
        const backgroundLayerElement = createBackgroundLayerElement('gradient', nodeId, breakpoint, index);
        backgroundLayerWrapper.appendChild(backgroundLayerElement);
      } else if (isBackgroundLayerImage(backgroundLayer) && backgroundLayer.imageUrl) {
        const backgroundLayerElement = createBackgroundImageLayerElement(backgroundLayer, nodeId, breakpoint, index);
        backgroundLayerWrapper.appendChild(backgroundLayerElement);
      }
    });
    div.appendChild(backgroundLayerWrapper);
  });
  return div;
}
export function createDndAreaSectionElement(gridNode) {
  const section = document.createElement('section');
  section.classList.add(DND_GRID_AREA_SECTION_CLASS_NAME);
  section.classList.add(`${DND_GRID_AREA_SECTION_CLASS_NAME_PREFIX}${gridNode.getId()}`);
  section.setAttribute(GRID_DATA_ATTRIBUTE_NODE_MAP[GRID_NODE_TYPES.SECTION], `${gridNode.getId()}`);
  const sectionContent = document.createElement('div');
  sectionContent.classList.add(DND_GRID_AREA_SECTION_CONTENT_CLASS_NAME);
  sectionContent.classList.add(`${DND_GRID_AREA_SECTION_CONTENT_CLASS_NAME_PREFIX}${gridNode.getId()}-content`);
  section.appendChild(sectionContent);
  const backgroundLayers = createBackgroundLayersElement(gridNode);
  section.prepend(backgroundLayers);
  return section;
}
export function createDndAreaContainerElement(gridNode) {
  const div = document.createElement('div');
  div.classList.add(DND_GRID_AREA_CONTAINER_CLASS_NAME);
  div.classList.add(`${DND_GRID_AREA_CONTAINER_CLASS_NAME_PREFIX}${gridNode.getId()}`);
  div.setAttribute(GRID_DATA_ATTRIBUTE_NODE_MAP[GRID_NODE_TYPES.CONTAINER], `${gridNode.getId()}`);
  const backgroundLayers = createBackgroundLayersElement(gridNode);
  div.prepend(backgroundLayers);
  return div;
}
export function createDndAreaModuleElement(gridNode) {
  const div = document.createElement('div');
  div.classList.add(DND_GRID_AREA_MODULE_CLASS_NAME);
  div.classList.add(...DND_GRID_AREA_MODULE_RENDERER_CLASS_NAMES);
  div.setAttribute(GRID_DATA_ATTRIBUTE_NODE_MAP[GRID_NODE_TYPES.MODULE], `${gridNode.getId()}`);
  div.setAttribute('id', `${DND_GRID_AREA_MODULE_ELEMENT_ID_PREFIX}${gridNode.getId()}`);
  return div;
}